import axios from 'axios'
import { getUiServicesEndpoint } from './utils'
import { logEvent, LogLevel } from '@praxis/component-logging'
import {
  ReverseCarriersRateParams,
  ReverseLogisticsCarrierInterface,
} from '../common/types'

type ReverseCarriersRateQuoteResponse = {
  carrier_list: ReverseLogisticsCarrierInterface[]
}

export const getReverseCarriers = async (
  params: ReverseCarriersRateParams,
): Promise<ReverseCarriersRateQuoteResponse> => {
  const { key, url } = await getUiServicesEndpoint()
  const endpoint = `${url}/v1/reverse_logistics_carriers`
  const toSnakeCaseParams = (params: ReverseCarriersRateParams) => ({
    origin_loc_code: params.originLocCode,
    destination_loc_code: params.destinationLocCode,
    business_unit: params.businessUnit,
    user_provided_pickup_date: params.userProvidedPickupDate,
    carton_qty: params.cartonQty,
    volume: params.volume,
    pallets: params.pallets,
    weight: params.weight,
  })
  return axios
    .get<ReverseCarriersRateQuoteResponse>(endpoint, {
      params: { key, ...toSnakeCaseParams(params) },
    })
    .then((response) => response.data ?? { carrier_list: [] })
    .catch((err: any) => {
      logEvent(
        {
          message: JSON.stringify({
            endpoint: endpoint,
            error: err?.response?.data ?? err?.message,
            status: err?.response?.status,
            message: err?.message,
            type: 'REQUEST_FAILURE',
            user: localStorage?.userInfo,
          }),
          url: window.location.href,
        },
        { level: LogLevel.Error },
      )

      throw new Error('Failed to load carriers. Please try again later.')
    })
}
